require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-joe-wicks-shape-plan-book-2-review.json") })
        }
      }, "path---post-joe-wicks-shape-plan-book-2-review");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-joe-wicks-shape-plan-book-2-review!./.cache/json/post-joe-wicks-shape-plan-book-2-review.json
// module id = 331
// module chunks = 231608221292675